import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModuleWeb } from '../material/material.module';
import { WebScreenComponent } from './web-screen.component';
import { WebWidgetCoreModule } from '../widget-core/web-widget-core.module';
import { GridsterModule } from '@hyperviewhq/angular2gridster';


@NgModule({
  declarations: [WebScreenComponent],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    DragDropModule,
    CdkDrag,
    WebWidgetCoreModule,
    GridsterModule.forRoot()
  ],
  exports:[WebScreenComponent]
})
export class WebScreenModule { 
  
}
